import React from "react";
import { DayTimeInput } from "@sinch/components/form/DayTimeInput/DayTimeInput";
import { DayTimeInputProps } from "@sinch/components/form/DayTimeInput/types";

export const StringTimeInput = ({
  value,
  onChange,
  timePoint,
  ...props
}: Omit<DayTimeInputProps, "value" | "onChange"> & {
  value: string;
  onChange?: (val: string) => void;
}) => (
  <DayTimeInput
    onChange={(val) => onChange?.(val ?? "00:00")}
    timePoint={timePoint ?? undefined}
    value={value}
    {...props}
  />
);
